import { motion } from 'framer-motion';
import type { Player } from '../../types/kotch';

interface PlayerTransitionProps {
  player: Player;
  isAttacker: boolean;
  battleNumber: number;
  roundNumber: number;
  onReady: () => void;
}

export default function PlayerTransition({
  player,
  isAttacker,
  battleNumber,
  roundNumber,
  onReady,
}: PlayerTransitionProps) {
  const role = isAttacker ? 'Attacker' : 'Defender';
  const roleDescription = isAttacker
    ? 'You commit cards first. The defender will see which lanes you commit to, but not your cards.'
    : 'You will see which lanes the attacker committed to. Choose your response wisely.';

  return (
    <motion.div
      className="kotch-transition"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h2>{player.name}</h2>

      <p>Battle {battleNumber}, Round {roundNumber}</p>

      <div className={`kotch-transition-role ${isAttacker ? 'attacker' : 'defender'}`}>
        <span>{isAttacker ? '⚔' : '🛡'}</span>
        <span>{role}</span>
      </div>

      <p style={{ maxWidth: 400, lineHeight: 1.6 }}>{roleDescription}</p>

      <button className="kotch-button" onClick={onReady}>
        Ready
      </button>
    </motion.div>
  );
}
